"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.syncAmplitudeConsent = exports.syncGoogleAdsConsent = void 0;
const analytics_1 = require("@commercial-website/analytics");
const google_ads_consents_1 = require("./google-ads-consents");
const mappers_1 = require("./mappers");
const store_1 = require("./store");
const syncGoogleAdsConsent = () => {
    (0, google_ads_consents_1.setDefaultConsentsState)();
    return store_1.$consentPreferences.subscribe((prefs) => {
        (0, google_ads_consents_1.updateConsentsState)((0, mappers_1.mapHubspotConsentToGoogleAdsPreferences)(prefs), {
            cookiePrefix: 'managed',
        });
    });
};
exports.syncGoogleAdsConsent = syncGoogleAdsConsent;
const syncAmplitudeConsent = ({ amplitudeKey, env, analytics }) => {
    let isInitialized = false;
    return store_1.$consentPreferences.subscribe((prefs) => {
        // FIXME: verify if we should switch to categories.analytics
        const consentHasBeenGiven = prefs.allowed || prefs.categories.advertisement;
        if (!consentHasBeenGiven || isInitialized) {
            return;
        }
        analytics.ready(() => {
            if (!isInitialized) {
                (0, analytics_1.initializeAmplitude)({
                    amplitudeKey,
                    env,
                    allowedEnvs: ['production', 'staging', 'feature'],
                });
                isInitialized = true;
            }
        });
    });
};
exports.syncAmplitudeConsent = syncAmplitudeConsent;
